import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { getDHM } from '@/utils/dhmCalculation';
import { getPrice } from '../BidCenter/bidCenterUtils';
import BidCenterHeader from '../BidCenter/BidCenterHeader';

const PDPHeaderStick = ({
  statusPayload,
  pdpBidCenter,
  listingType,
  status,
  offerType,
  offerCenterDetail,
  isSignedUser,
  isFcOnlineFlag,
  pdpData,
  financialType,
  pdpPropertyFees,
  isWatchProperty,
  getCurrentTime
}) => {
  const pdpInitData = useSelector((state) => state.pdp.pdpInitData);
  const bidCenterData = useSelector((state) => state.pdp.bidCenterData);
      const auctionDetails = useSelector((state) => state.pdp.auctionDetails);
  const price = getPrice({
    listingType,
    statusPayload,
    bidCenterData,
    offerCenterDetail,
    pdpInitData,
    propCategory: pdpInitData?.propertyDetails?.commonAttributes?.propCategory,
    estimatedOpeningBid: pdpInitData?.propertyDetails?.detailedAttributes?.estimatedOpeningBid,
    auctionDetails
  });

  if (!(getCurrentTime?.days || getCurrentTime?.hours || getCurrentTime?.minutes)) {
    return <div />;
  }
  return (
    <div className="pdp-header-right-stick pt10">
      <div className="listing_list_style justify-content-end d-flex">
        {/* <div className="list-inline-item right-bar">
          <p className="time-left-txt">Time Left</p>
          <p className="listing-time">{timeLeft || 0} {getCurrentTime?.days ? "days" : getCurrentTime?.hours ? "hours" : getCurrentTime?.minutes ? "minutes" : ""}</p>
        </div> */}
        {/* <div className="list-inline-item pr10">
          <p className="time-left-txt">{price?.label}</p>
          <p className="listing-time">{price?.amount}</p>
        </div> */}
        <BidCenterHeader
          statusPayload={statusPayload}
          pdpBidCenter={pdpBidCenter}
          listingType={listingType}
          status={status}
          offerType={offerType}
          offerCenterDetail={offerCenterDetail}
          isSignedUser={isSignedUser}
          isFcOnlineFlag={isFcOnlineFlag}
          pdpData={pdpData}
          financialType={financialType}
          pdpPropertyFees={pdpPropertyFees}
          isWatchProperty={isWatchProperty}
          priceLabel={price?.label}
          priceAmount={price?.amount}
          timeLeft={(getCurrentTime?.days || getCurrentTime?.hours || getCurrentTime?.minutes) || 0}
          timeLeftUnit={getCurrentTime?.days ? "days" : getCurrentTime?.hours ? "hours" : getCurrentTime?.minutes ? "mins" : ""}
          isLastFewMins={(!getCurrentTime?.days && !getCurrentTime?.hours && getCurrentTime?.minutes) && ((getCurrentTime?.days || getCurrentTime?.hours || getCurrentTime?.minutes) <= 15) ? true : false}
        />
      </div>
    </div>
  );
};
export default PDPHeaderStick;